import { render } from "./ClientesGasList.vue?vue&type=template&id=30d607a2&scoped=true"
import script from "./ClientesGasList.vue?vue&type=script&lang=js"
export * from "./ClientesGasList.vue?vue&type=script&lang=js"

import "./ClientesGasList.vue?vue&type=style&index=0&id=30d607a2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d607a2"]])

export default __exports__